import { __assign, __generator } from "tslib";
import { eventChannel } from 'redux-saga';
import { call, fork, put, take } from 'redux-saga/effects';
import { locationChanged } from '../actionCreators';
import * as locationUtils from '../utils/location';
import { syncHistory } from './history';
export default function locationSaga(dispatch, history) {
    var savedState, currentLocation, match, historyChannel, location, newMatch;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                currentLocation = history.location;
                match = getURLParts(currentLocation);
                /*
                 * This event triggers project information to be saved
                 * in the store. Without this, the project will not load
                 */
                return [4 /*yield*/, put(locationChanged(match, currentLocation))];
            case 1:
                /*
                 * This event triggers project information to be saved
                 * in the store. Without this, the project will not load
                 */
                _a.sent();
                /*
                 *  Listen to actions that should trigger location change
                 * (non-blocking, so that the history listener can run)
                 */
                return [4 /*yield*/, fork(syncHistory, history, savedState)];
            case 2:
                /*
                 *  Listen to actions that should trigger location change
                 * (non-blocking, so that the history listener can run)
                 */
                _a.sent();
                return [4 /*yield*/, call(createHistoryChannel, history)];
            case 3:
                historyChannel = _a.sent();
                _a.label = 4;
            case 4:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, take(historyChannel)];
            case 5:
                location = _a.sent();
                newMatch = getURLParts(location);
                return [4 /*yield*/, put(locationChanged(newMatch, location))];
            case 6:
                _a.sent();
                return [3 /*break*/, 4];
            case 7: return [2 /*return*/];
        }
    });
}
function getURLParts(location) {
    var match = locationUtils.parse(location);
    if (location.state) {
        match = __assign(__assign({}, match), location.state);
    }
    if (!match.hotspotID) {
        match.hotspotID = null;
    }
    return match;
}
/*
 * Listen to navigation events, e.g. back button
 * location - location that we're navigating to
 * action - current location action
 */
function createHistoryChannel(history) {
    return eventChannel(function (emit) {
        var locationHandler = function (location) {
            // puts location into the channel to give the Saga access to it
            emit(location);
        };
        var unlisten = history.listen(function (location, action) {
            if (action === 'POP') {
                locationHandler(location);
            }
        });
        // The subscriber must return an unsubscribe function
        return unlisten;
    });
}
